/**
 * Mobile menu
 */
const componentMobileMenu = (args) => {

  // setup args
  let menu     = args.menu;
  let site     = args.site;
  let toggles  = args.toggles;

  // validate
  if (!menu || !site || !toggles.length) {
    console.log('Invalid mobile_menu args');
    return;
  }

  // setup a11y dialog
  const dialog = new A11yDialog(menu, site);

  // tasks to open menu visually
  const openMenu = () => {
   document.body.classList.add('is-active-menu');
  };

  // tasks to close menu visually
  const closeMenu = () => {

    document.body.classList.add('is-closing-menu');
    setTimeout(() => {
      document.body.classList.remove('is-active-menu');
      document.body.classList.remove('is-closing-menu');
      document.body.classList.remove('is-active-search'); // Remove is-active-search class
     }, 200);

  };

  // hooks
  dialog.on('show', (element, event) => {
    openMenu();
  });
  dialog.on('hide', (element, event) => {
    closeMenu();
  });

  // toggle click
  const handleToggle = (e) => {
    const toggle = e.currentTarget;

    if (document.body.classList.contains('is-active-menu')) {

    // menu open and click search
    if (document.body.classList.contains('is-active-menu') && !document.body.classList.contains('is-active-search')) {

      if (toggle.classList.contains('menu-toggle-search')) {
        document.body.classList.add('is-active-search');

        // Focus mobile menu search input
        document.querySelector('.mobile-menu .search-form__input').focus();

      } else {
        dialog.hide();
      }

    // search open and click menu
    } else if (document.body.classList.contains('is-active-search')) {

      if (toggle.classList.contains('menu-toggle') && !toggle.classList.contains('menu-toggle-search')) {
        document.body.classList.remove('is-active-search');
      } else {
        dialog.hide();
      }

    } else {
      dialog.hide();
    }


    } else {
      dialog.show();
      if (toggle.classList.contains('menu-toggle-search')) {
        document.body.classList.add('is-active-search');

        // Focus mobile menu search input
        document.querySelector('.mobile-menu .search-form__input').focus();

      } else {
        document.body.classList.remove('is-active-search');
      }
    }
  };

  // close on anchor link
  const anchorLinks = menu.querySelectorAll('a[href*="#"]');
  for (let i = 0; i < anchorLinks.length; i++) {
    if (anchorLinks[i].getAttribute('href') !== '#') {
      anchorLinks[i].addEventListener('click', (e) => {
        dialog.hide();
      });
    }
  }

  for (let i = 0; i < toggles.length; i++) {
    toggles[i].addEventListener('click', handleToggle, false);
  }

  // make the call chainable
  return this;

};

/**
 * Init mobile menu
 */
componentMobileMenu({
  menu:     document.querySelector('.js-mobile-menu'),
  site:     document.querySelector('.js-page'),
  toggles:  document.querySelectorAll('.js-menu-toggle')
});
